import firebase from "./firebaseInit";

export const storage = firebase.storage().ref()
export const images = storage.child('images')
export const artworksRef = storage.child('artworks')
export const temp = storage.child('temp')
export const personStorage = storage.child('person')